export default {
  generalInformation: {
    title: 'Informacje ogólne',
    company: 'Firma',
    street: 'Ulica',
    postalCode: 'Kod pocztowy',
    city: 'Miasto',
    state: 'Państwo',
    country: 'Kraj',
    email: 'E-mail',
    phone: 'Telefon',
    fax: 'Faks',
    cellPhone: 'Telefon komórkowy',
  },
  contact: {
    firstName: 'Imię',
    lastName: 'Nazwisko',
    jobTitle: 'Stanowisko',
    phone: 'Telefon 1',
    extensionPhone: 'Rozszerzenie',
    secondPhone: 'Telefon 2',
    cellPhone: 'Telefon komórkowy',
    privateMail: 'E-mail',
    addContact: 'Dodaj kontakt',
  },
};
